export default "__VITE_ASSET__Df2KrApf__"